import {useGetAccessTypes} from '@/features/access-types/queries/useGetAccessTypes'
import {AccessGroupNameEnum, AccessTypeCategoryEnum} from '@/features/access-types/types'
import {useInputSearch} from '@/hooks/useInputSearch'
import {ResponseType} from '@/types'
import {useMemo} from 'react'

export const useAccessTypesSearchableList = ({
    groupName,
    category,
    specializationId,
    responseType,
    limit = 10,
    enabled
}: {
    groupName?: AccessGroupNameEnum
    category?: AccessTypeCategoryEnum
    specializationId?: string
    responseType: ResponseType
    limit?: number
    enabled?: boolean
}) => {
    const searchControls = useInputSearch()
    const query = useGetAccessTypes({
        params: {
            search: searchControls.searchValue,
            groupName,
            category,
            specializationId,
            responseType,
            limit,
            page: 1
        },
        options: {enabled}
    })

    const accessTypes = useMemo(() => query.data?.pages.flatMap(page => page.data) ?? [], [query.data])

    return {
        ...query,
        ...searchControls,
        accessTypes
    }
}
